import { lazy } from "react";

const Index = lazy(() => import("./AutoReply"));

const Create = lazy(() => import("./Create"));

export { Index, Create };
